module.exports = __webpack_public_path__ + "static/img/1huada.9b81a6b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/1huada.jpg
// module id = q2Cn
// module chunks = 1 2 3 4 5 6 7 8 9 10